import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "../../services/CRUDServices";

export const filterCnsignmentDelivery: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "consignment-delivery-report",
  async (body: any) => {
    let { data } = await filterTableDataAPI(
      "/consignment-api/consignment/v1/s0/pendingCounterReport",
      body.pageNumber,
      {
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },
      true,
      10,
      false
    );
    return { data:data.response };
  }
);

const initialState: any = {
  consignmetnDeliveryReportLists: [],
  fetchpost: false,
  errorMessage: null,
  filter: {},
};

const ConsignmentDeliveryreportSlice = createSlice({
  initialState: initialState,
  name: "consignment-delivery-report",
  reducers: {

    // clearGroupPayment: (state) => {
    //   state.deliveryList = [];
    // },
    setfilterCnsignmentDelivery: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterCnsignmentDelivery.fulfilled as any]: (state, action) => {
      state.consignmetnDeliveryReportLists = action.payload.data;
      state.fetchpost = false;
    },
    [filterCnsignmentDelivery.pending as any]: (state) => {
      state.fetchpost = true;
    },
    [filterCnsignmentDelivery.rejected as any]: (state) => {
      state.fetchpost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const {  setfilterCnsignmentDelivery } = ConsignmentDeliveryreportSlice.actions;
export default ConsignmentDeliveryreportSlice.reducer;


